import { render, staticRenderFns } from "./draftModal.vue?vue&type=template&id=680f9ee3&"
import script from "./draftModal.vue?vue&type=script&lang=js&"
export * from "./draftModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports